import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bc07abb"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Internal error")
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "grid m-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xl:col-3" }, null, -1))
const _hoisted_5 = { class: "p-0 col-12 md:col-9 xl:col-6" }
const _hoisted_6 = { class: "flex flex-column border-right-1 border-left-1 border-bottom-1 border-300" }
const _hoisted_7 = { class: "hidden md:block md:col-3" }

import { useQuery } from "@vue/apollo-composable";
import { ref, watch } from "@vue/runtime-core";
import NavBar from "@/components/NavBar.vue";
import gql from "graphql-tag";
import PostList from "@/components/post/PostList.vue";
import router from "../router";
import { useRoute } from "vue-router";
import TagListCard from "@/components/tag/TagListCard.vue";


export default /*#__PURE__*/_defineComponent({
  emits: ["on-router-view-reload"],
  setup(__props, { emit }) {



const route = useRoute();
const currentPage = parseInt(route.query.p?.[0]!)
const rowsPerPage = parseInt(localStorage.getItem("postNbOption") || '25');

if (isNaN(currentPage) || currentPage < 1) {
  router.push(`/?p=1`);
}

const variables = ref({
  limit: rowsPerPage,
  offset: (currentPage - 1) * rowsPerPage,
});

const { result, loading, error, refetch } = useQuery(
  gql`
    query getPosts($limit: Int, $offset: Int) {
      post_aggregate {
        aggregate {
          count
        }
      }
      post(order_by: { created_at: desc }, limit: $limit, offset: $offset) {
        url
        uuid
        created_at
        description
        title
        user {
          id
          username
        }
        comments_aggregate {
          aggregate {
            count
          }
        }
        post_tags(order_by: { tag: { name: asc } }) {
          tag {
            name
          }
        }
        bookmarks {
          uuid
        }
      }
      tag(order_by: {post_tags_aggregate: {count: desc}}) {
        name
        post_tags_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  `,
  variables,
  {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  }
);

watch(result, (value) => {
  if (
    value &&
    currentPage >
    Math.ceil(value.post_aggregate.aggregate.count / rowsPerPage)
  ) {
    router.push({ params: { p: 1 } });
  }
});

const changePage = ({ page }: { page: number }) => {
  router.push(`/?p=${page + 1}`);
};

const updatePostNb = () => {
  emit('on-router-view-reload')
}

return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Message = _resolveComponent("Message")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavBar),
    (_unref(loading))
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "spinner"
        }))
      : (_unref(error))
        ? (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            severity: "error"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }))
        : (_unref(result).post)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_Paginator, {
                      first: variables.value.offset,
                      totalRecords: _unref(result).post_aggregate.aggregate.count,
                      rows: _unref(rowsPerPage),
                      onPage: _cache[0] || (_cache[0] = ($event: any) => (changePage($event)))
                    }, null, 8, ["first", "totalRecords", "rows"]),
                    _createVNode(PostList, {
                      posts: _unref(result).post,
                      onOnRefresh: _unref(refetch),
                      onOnPostNbChange: updatePostNb
                    }, null, 8, ["posts", "onOnRefresh"]),
                    _createVNode(_component_Paginator, {
                      first: variables.value.offset,
                      totalRecords: _unref(result).post_aggregate.aggregate.count,
                      rows: _unref(rowsPerPage),
                      onPage: _cache[1] || (_cache[1] = ($event: any) => (changePage($event)))
                    }, null, 8, ["first", "totalRecords", "rows"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(TagListCard, {
                    tags: _unref(result).tag,
                    class: ""
                  }, null, 8, ["tags"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ], 64))
}
}

})